/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_Color_BlueInputs */



/**
* | output |
* | --- |
* | "Set Color Blue" |
*
* @param {Shortcut_Keys_Name_Set_Color_BlueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_color_blue = /** @type {((inputs?: Shortcut_Keys_Name_Set_Color_BlueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_Color_BlueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set Color Blue")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set Color Blue")
	return /** @type {LocalizedString} */ ("Set Color Blue")
});